// extracted by mini-css-extract-plugin
export default {"root":"CustomFilterPopup_root__nV6Gt","label":"CustomFilterPopup_label__DugxB","labelSelected":"CustomFilterPopup_labelSelected__mDVcI"};